export const updateUserDto= {
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    city: null,
    state: null,
    countryCode: null,
    jobTitle: null,
    active: null,

    isSubscriptionManager: null,
    isCompanyAdmin: null,
    isLibraryManager: null,
    isSifManager: null,
    isVmidParticipation:null,
    isVmidFileUpload:null,
    isAcquirerVmid:null,
    hasVisaInternalExtendedAccess: null,
    hasVstsL0: null,
    adminVstsEntitlement: null,
    isVstsWorkflowAdmin: null,
    hasReportingExport: null,
}